(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('FavoritesDeleteController', FavoritesDeleteController);

    FavoritesDeleteController.$inject = ['$scope', '$uibModalInstance', '$translate', 'FavoritesService', 'favorite'];

    function FavoritesDeleteController($scope, $uibModalInstance, $translate, FavoritesService, favorite) {
        var vm = this;
        vm.requestRunning = false;

        $translate('favorites.' + favorite.action).then(function (translation) {
            vm.favorite = {action: translation};
        });

        vm.close = function () {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.delete = function () {
            vm.requestRunning = true;
            FavoritesService.deleteFavorite(favorite.id).then(successDelete).catch(errorDelete);
        }

        function successDelete(data) {
            FavoritesService.successModalConstructor('delete');
            vm.requestRunning = false;
            $scope.$emit('favoriteDeleted', data);
        }

        function errorDelete(response) {
            vm.requestRunning = false;
            FavoritesService.errorModalConstructor(response, 'delete');
        }

    }
})();